import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function VersionBadge() {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/version`)
      .then(res => res.json())
      .then(data => setVersion(data))
      .catch(() => setVersion({ version: '?', build: '?' }));
  }, []);

  if (!version) return null;

  return (
    <span style={{
      position: 'fixed',
      bottom: '8px',
      right: '16px',
      fontSize: '11px',
      color: 'rgba(255,255,255,0.4)',
      zIndex: 9999,
      userSelect: 'none',
      pointerEvents: 'none',
      fontFamily: 'monospace'
    }}>
      v{version.version}{version.build && version.build !== 'dev' ? `+build.${version.build}` : ''}
    </span>
  );
}

export default VersionBadge;
